/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Unique identification of the agent, which is responsible for this business transaction.   (german: Vermittler)   (bipro-gevo::Vermittler)
 */
export interface Agent {
  /**
   * Unique agent number assigned by Verti.   (bipro-gevo::VermittlerVU)
   */
  agentNumber: string;
  /**
   * Unique agent number within the external company resp. API consumer.   For informational purposes only.   (bipro-gevo::VermittlerVM)
   */
  agentNumberExternal?: string;
}
